/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

export interface PanDetailsFormState {
  status: 'idle' | 'loading' | 'success' | 'error';
  isPanImageSaved: boolean,
  panDetails: {
    panNumber: string | null,
    birthDate: string | null,
  };
  panNumber: string | null,
  isPanConfirmed: boolean,
  error: {
    isError: boolean,
    type: string | null,
    message: string | null
  }
}

const initialState: PanDetailsFormState = {
  status: 'idle',
  panDetails: {
    panNumber: null,
    birthDate: null,
  },
  panNumber: null,
  isPanImageSaved: false,
  isPanConfirmed: false,
  error: {
    isError: false,
    type: null,
    message: '',
  },
};

export const panDetailsFormSlice = createSlice({
  name: 'panDetailsForm',
  initialState,
  reducers: {
    verifyPanNumber: (state, action) => {},
    savePanImage: (state, action) => {},
    setPanVerificationData: (state, action) => {
      state.panDetails.panNumber = action.payload.pan;
      state.panDetails.birthDate = action.payload.dateOfBirth;
      state.status = 'success';
    },
    confirmPan: (state) => {
      state.status = 'loading'
    },
    setPanNumber: (state, action) => {
      state.panNumber = action.payload;
    },
    setPanImageStatus: (state, action) => {
      state.isPanImageSaved = action.payload.isPanImageSaved;
      state.status = 'success';
    },
    setPanDetailsFormError: (state, action) => {
      state.error = action.payload;
      state.status = 'error';
    },
    setPanDetailsFormStatus: (state, action) => {
      state.status = action.payload;
    },
    setConfirmPan: (state, action) => {
      const { isConfirmPan, status } = action.payload
      state.status = status
      state.isPanConfirmed = isConfirmPan
    },
    clearPanDetailsFormError: (state) => {
      state.error = {
        isError: false,
        type: null,
        message: '',
      };
      state.status = 'idle';
      state.isPanConfirmed = false
    },
  },
});

export const {
  verifyPanNumber, savePanImage, setPanVerificationData, setPanImageStatus,
  setPanNumber, setPanDetailsFormError, setPanDetailsFormStatus, clearPanDetailsFormError, setConfirmPan, confirmPan,
} = panDetailsFormSlice.actions;

export default panDetailsFormSlice.reducer;
